import React from 'react';
import { Link } from 'react-router-dom';
import './LimitWarning.css';

/**
 * Component to display limit warnings or errors
 * @param {Object} props Component props
 * @param {Object} props.limitCheck Result from checkResourceLimits
 * @param {string} props.resourceType The type of resource (agent, query, document)
 * @param {boolean} props.isError True if this is an error, false for a warning
 */
const LimitWarning = ({ limitCheck, resourceType, isError = false }) => {
  if (!limitCheck || (limitCheck.allowed && !limitCheck.warning)) {
    return null;
  }

  // Format resource type for display
  const formattedResourceType = resourceType.charAt(0).toUpperCase() + resourceType.slice(1);
  
  // Add plural form if needed
  const resourceTypePlural = formattedResourceType + (formattedResourceType.endsWith('s') ? 'es' : 's');
  
  return (
    <div className={`limit-notification ${isError ? 'limit-error' : 'limit-warning'}`}>
      <div className="limit-icon">
        {isError ? '⚠️' : '⚠'}
      </div>
      <div className="limit-content">
        <h4>{isError ? 'Limit Reached' : 'Limit Approaching'}</h4>
        <p>
          {isError 
            ? `You've reached your ${resourceTypePlural} limit (${limitCheck.current}/${limitCheck.limit}).` 
            : `You're approaching your ${resourceTypePlural} limit (${limitCheck.current}/${limitCheck.limit}).`
          }
        </p>
        
        {limitCheck.usagePercent && (
          <div className="limit-progress">
            <div className="limit-progress-bar" style={{ width: `${Math.min(100, limitCheck.usagePercent)}%` }}></div>
          </div>
        )}
        
        {isError && (
          <Link to="/pricing" className="limit-upgrade-button">
            Upgrade Plan
          </Link>
        )}
      </div>
    </div>
  );
};

export default LimitWarning; 